function ArbitrageTable({data}){

 return(

 <table>

 <thead>

 <tr>

 <th>Symbol</th>
 <th>Buy</th>
 <th>Sell</th>
 <th>Spread %</th>

 </tr>

 </thead>

 <tbody>

 {data.map((r,i)=>(

 <tr key={i}>

 <td>{r.symbol}</td>
 <td>{r.buy_exchange}</td>
 <td>{r.sell_exchange}</td>
 <td>{r.spread_percent.toFixed(3)}</td>

 </tr>

 ))}

 </tbody>

 </table>

 )
}

export default ArbitrageTable